import { useState } from 'react';
import { Box, Typography } from '@mui/material';

import Notifications from '../Notifications';
import ProfileAvatarButton from './ProfileAvatarButton';
import { LanguageSwitcher } from '../../../base';
import { Roles } from '../../../../constants';
import { areUserRolesIn } from '../../../../helpers';
import { SupportedLanguages } from '../../../../admin/constants/general';
import { ONBOARDING_QUESTIONNAIRE_BASE_PATH } from '../../../../pages/questionnaires/onboarding/constants';
import {
  HEADER_ACTIONS_SX,
  LANGUAGE_SWITCHER_SX,
  TRANSLATION_DISCLAIMER_SX,
} from '../styles';

import type { MouseEvent } from 'react';
import type { HeaderActionsProps } from '../types';

export default function HeaderActions({
  i18n,
  pathname,
  provider,
  providerLoading,
  t,
  user,
  userState,
}: HeaderActionsProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box sx={HEADER_ACTIONS_SX}>
      {i18n.resolvedLanguage === SupportedLanguages.Spanish ? (
        <Typography sx={TRANSLATION_DISCLAIMER_SX} variant="subtitle2">
          {t('translationDisclaimer', { ns: 'common' })}
        </Typography>
      ) : null}
      {areUserRolesIn(userState?.roles, [Roles.Guardian]) &&
      !providerLoading &&
      provider &&
      provider.supported_languages &&
      provider.supported_languages.length > 1 &&
      !pathname.includes(ONBOARDING_QUESTIONNAIRE_BASE_PATH) ? (
        <LanguageSwitcher variant="inline" sx={LANGUAGE_SWITCHER_SX} />
      ) : null}
      {areUserRolesIn(userState?.roles, [Roles.Prbt, Roles.Vbt]) ? <Notifications /> : null}
      <ProfileAvatarButton
        user={user}
        open={open}
        anchorEl={anchorEl}
        onClick={handleClick}
        onClose={handleClose}
      />
    </Box>
  );
}
